'use client';

import { FlexTemplate } from '@asurion-core/mx-asurion-ui-react';
import styled from 'styled-components';

const FlexTemplateBase = styled(FlexTemplate)`
  // Replacing fixed height with min-height and height auto
  // adds support for layouts with footers while retaining
  // expected sticky layout structure
  height: auto;
  min-height: calc(100vh - ${(props) => props?.upperVerticalOffset});

  grid-template-areas:
    'progress-stepper'
    'main-content'
    'side-panel'
    'button-group';

  @media (min-width: 768px) {
    grid-template-areas:
      'main-content'
      'side-panel'
      'button-group';
  }

  @media (min-width: 1024px) {
    grid-template-areas:
      'main-content side-panel'
      'button-group side-panel';
    grid-template-columns: 7fr 5fr;
    grid-template-rows: 1fr;
    min-height: calc(100vh - 0rem);
    height: auto;

    & > :nth-child(2) {
      max-width: 474px;
    }
  }
`;

export const {
  ButtonGroup,
  Heading,
  MainContentContainer,
  MainPanelContainer,
  PageTitleContainer,
  ProgressStepper,
  ProgressStepperContainer,
  SidePanelContainer,
  Subheading,
} = FlexTemplate;

export default FlexTemplateBase;
